import { Component, Input, OnInit,EventEmitter,Output,ViewChild,ElementRef } from '@angular/core'
import { FormAtylBase } from '../../../../form-atyl-base'
import { InputLabelPipe } from '../../../../../pipes/atyl/inputLabel.pipe'


import SignaturePad from 'signature_pad';

@Component({
	selector: 'atyl-form-input-signature',
	templateUrl: './form-input-signature.component.html',
	styleUrls: ['./form-input-signature.component.scss']
})
export class FormInputSignatureComponent implements OnInit {

	signatureNeeded!: boolean;
  	signaturePad!: SignaturePad;
  	@ViewChild('containerSignature', { static: false }) containerEl!: HTMLElement;
  	
  	@ViewChild('canvasSignature', { static: false }) canvasEl!: ElementRef;
  	signatureImg!: string;
  	
	//@ViewChild(SignaturePad, { static: true }) signaturePad: SignaturePad;
	@Input() forminput: FormAtylBase<any>
	@Input() group: any
	@Input() isValid: boolean
	@Input() errorMessage: any
	@Input() outline: any
	@Input() disabled: boolean
	@Output() inputTyped = new EventEmitter<any>();
	
    label:string;
    errorString:string;
    
    public src: string;
  	public clearMe = false;
  	public signing = true;
    
    signaturePadOptions: any = { // passed through to szimek/signature_pad constructor
    'minWidth': 5,
    'canvasWidth': 500,
    'canvasHeight': 300
  };
  
	constructor(
		private readonly inputLabelPipe: InputLabelPipe
	) { }
	
	ngOnInit(): void {
		
		this.label = this.inputLabelPipe.transform(this.forminput)
		console.log("FormInputSignatureComponent",this.label,this.forminput);
		this.errorString = this.errorMessage && this.errorMessage[0] ? this.errorMessage[0] : ''
		
		

		
		
	}
	ngAfterViewInit() {
		
		const myElement = document.getElementById('containerSignature'+this.forminput.ID);
		let width:number=500;
		if(myElement) {
			width=myElement.getBoundingClientRect().width;
			width-=(1/100)*width;
		}
		this.canvasEl.nativeElement.width=width;
				
    this.signaturePad = new SignaturePad(this.canvasEl.nativeElement);
    
    if(this.forminput && this.group.get(this.forminput.ID)
     &&  this.group.get(this.forminput.ID).value!=undefined
    &&  this.group.get(this.forminput.ID).value
    && this.group.get(this.forminput.ID).value.length>0
    &&  this.group.get(this.forminput.ID).value != ""){
		this.signaturePad.fromDataURL(this.group.get(this.forminput.ID).value);
    }
   }


  
  
  startDrawing(event: Event) {
    // works in device not in browser
	console.log("signature draw");
	if (!this.signaturePad.isEmpty()) {
	var data = this.signaturePad.toDataURL();
	console.log("signature draw",data);
	}
 }
	moved(event: Event) {
    // works in device not in browser
	console.log("signature moved");
	if (!this.signaturePad.isEmpty()) {
			
		  

		var data = this.signaturePad.toDataURL();
		console.log("signature moved",data);
	}
	
  }
  
	  savePad() {
	    console.log("signature savePad");
		if (!this.signaturePad.isEmpty()) {
				
			  
	
			var data = this.signaturePad.toDataURL();
			console.log("signature savePad",data);
			
			this.group.get(this.forminput.ID).setValue(data);
		}
	 }
	 clearPad() {
	    this.signaturePad.clear();
	    this.group.get(this.forminput.ID).setValue(null);
	  }
	
}
